// components/parcours-client/StepperProgress.js
import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const ProgressWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "900px",
  margin: "auto",
  padding: "15px 10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  flexDirection: "column",
}));

const StyledLinearProgress = styled(LinearProgress)({
  height: 12,
  borderRadius: 15,
  width: "100%",
  backgroundColor: "#f1f1f1",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  "& .MuiLinearProgress-bar": {
    background: "linear-gradient(to right, #4eb933, #2d9a1a)",
    borderRadius: 15,
  },
});

// évite de forward la prop custom "progress" vers le DOM
const Cyclist = styled("div", { shouldForwardProp: (p) => p !== "progress" })(({ progress }) => ({
  position: "absolute",
  top: "-25px",
  fontSize: "40px",
  left: `calc(${progress}% - 15px)`,
  transform: "translateX(-50%) scaleX(-1)",
  transition: "left 0.4s ease",
  zIndex: 2,
}));

/**
 * Props:
 *  - currentStep: index 0-based
 *  - totalSteps: total réel d'étapes (ex: stepComponents.length)
 */
const StepperProgress = ({ currentStep = 0, totalSteps }) => {
  const { t } = useTranslation("parcours-client/StepperProgress");

  // Si jamais totalSteps n'est pas fourni, dernier recours: i18n
  const titles = t("steps", { returnObjects: true }) || [];
  const total =
    Number.isFinite(totalSteps) && totalSteps > 0
      ? totalSteps
      : (Array.isArray(titles) ? titles.length : 1);

  const safeTotal = Math.max(1, total);
  const safeCurrent = Math.min(Math.max(0, currentStep), safeTotal - 1);

  const progress = safeTotal > 1 ? (safeCurrent / (safeTotal - 1)) * 100 : 100;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
      <ProgressWrapper>
        <Box sx={{ position: "relative", width: "100%", maxWidth: "600px" }}>
          <Cyclist progress={progress}>🚴‍♂️</Cyclist>
          <StyledLinearProgress variant="determinate" value={progress} />
        </Box>
      </ProgressWrapper>

      <Typography
        variant="body2"
        sx={{ mt: 1, color: "#555", fontWeight: "bold", textTransform: "uppercase" }}
      >
        {t("stepLabel", { current: safeCurrent + 1, total: safeTotal })}
      </Typography>
    </Box>
  );
};

export default StepperProgress;